import * as React from 'react';
import { useSelector } from 'react-redux';

import { MessageReplyQuote } from '../../components/MessageReplyQuote';
import { useRepliesEnabled } from '../../hooks/useRepliesEnabled';
import { useReplyScrollStoreContext } from '../../utils/replyScrollContext';
import { currentOpenChatSelector } from '../../selectors';
import { getReplyAuthorName } from '../../utils/getReplyAuthorName';
import { useMessageContext } from '../../utils/messageContext';

import { getReplyQuoteContent } from './utils';

export const MessageReplyQuoteContainer: React.FC = () => {
  const {
    message: { reply, isOutcoming },
  } = useMessageContext();
  const isRepliesEnabled = useRepliesEnabled();

  const { scrollToReplyTargetMessage } = useReplyScrollStoreContext();

  const { users = [], chatId = '' } = useSelector(currentOpenChatSelector) || {};

  const quoteProps = React.useMemo(() => {
    if (!reply) {
      return null;
    }

    const { authorId, messageId } = reply;
    const authorName = getReplyAuthorName({ users, userId: authorId });
    const { text, thumbnail } = getReplyQuoteContent(reply, chatId);

    return { authorName, text, thumbnail, onClick: () => scrollToReplyTargetMessage(messageId) };
  }, [users, reply, chatId, scrollToReplyTargetMessage]);

  if (!isRepliesEnabled || !quoteProps) {
    return null;
  }

  return <MessageReplyQuote {...quoteProps} isOutcoming={isOutcoming} />;
};
